/**
 * 积分规则
 */
<template>
    <div class="visitor-wrapper">
        <div class="visitor-img">
            <img class="img" src="~@/assets/images/defaultvisitor.png" alt="">
            <div class="desc">{{areasName + doorwayName}}</div>
        </div>
        <div>
            <div class="visitor-tab">
                <div class="tab-item" :class="{'active': !showTab}" @click="handleTab(0)">业主/员工</div>
                <div class="tab-item" :class="{'active': showTab}" @click="handleTab(1)">访客</div>
            </div>
            <div></div>
        </div>
        <div>
            <div>
                <div v-if="showTab">
                    <div class="form-group">
                        <div class="form-lable">拜访人</div>
                        <div class="form-control form-input-wrapper">
                            <input v-model="proprietor" class="form-input" type="text" placeholder="例如：张三" maxlength="100">
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="form-lable">拜访地址</div>
                        <div class="form-control form-input-wrapper">
                            <input v-model="address" class="form-input" type="text" placeholder="例如：xx号楼x单元xxx室，x座xxx室" maxlength="500">
                        </div>
                    </div>
                </div>
                <div v-if="!showTab">
                    <div class="form-group">
                        <div class="form-lable">具体地址</div>
                        <div class="form-control form-input-wrapper">
                            <input v-model="address" class="form-input" type="text" placeholder="例如：xx号楼x单元xxx室，x座xxx室" maxlength="500">
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-lable">是否有车</div>
                    <div class="form-control">
                        <van-radio-group v-model="vehicleFlag" direction="horizontal">
                            <van-radio name="1">有</van-radio>
                            <van-radio name="0">无</van-radio>
                        </van-radio-group>
                    </div>
                </div>
                <div class="form-group" v-if="vehicleFlag == 1">
                    <div class="form-lable">车牌号</div>
                    <div class="form-control form-input-wrapper">
                      <input  v-model="vehicleNo" class="form-input" type="text" placeholder="例如：鲁Bxxxxx" maxlength="100">
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-lable">目前健康状况</div>
                    <div class="form-control form-checkbox">
                       <div class="item" :class="{'active': box1}" @click="handleCheckbox(1)">健康</div>
                       <div class="item" :class="{'active': box2 }" @click="handleCheckbox(2)" >咳嗽</div>
                       <div class="item" :class="{'active': box3 }" @click="handleCheckbox(3)">发烧</div>
                       <div class="item" :class="{'active': box4 }" @click="handleCheckbox(4)">乏力</div>
                       <div class="item" :class="{'active': box5 }" @click="handleCheckbox(5)">其他</div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-lable form-temperature">您的体温</div>
                    <div class="form-control form-input-wrapper">
                      <input @click="showPicker=true" v-model="temperature" class="form-input" type="text" placeholder="请选择温度" maxlength="100" readonly>
                      <van-popup v-model="showPicker" position="bottom">
                        <van-picker
                          title="温度值"
                          show-toolbar
                          :columns="columns"
                          @cancel="showPicker = false"
                          @confirm="onConfirm"
                        />
                      </van-popup>
                    </div>
                </div>
                <div class="form-group form-group-button">
                  <van-button :loading="loading" type="info" loading-text="提交中..." @click="handleSubmit">提交登记</van-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Toast, RadioGroup, Radio, Slider, Picker, Popup, Button } from 'vant'
import { getVisitorInfo, submitVisitorInfo } from '@/api/visitor'
import { setStore, removeStore } from '@/utils/index'

export default {
  components: {
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Slider.name]: Slider,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Button.name]: Button
  },
  data () {
    return {
      loading: false,
      showPicker: false,
      step: 0.1,
      detailId: '',
      showTab: false,
      registerType: 0,
      box1: false,
      box2: false,
      box3: false,
      box4: false,
      box5: false,
      areasName: '', // 小区名称，
      doorwayName: '', // 小区出入口名称
      proprietor: '', // 拜访人
      address: '', // 具体地址 // 拜访地址
      vehicleFlag: null,
      vehicleNo: '', // 车牌号
      healthyStatus: [], // 健康状况
      temperature: null, // 体温
      isActive: false,
      isColor: '#4f7cf6',
      columns: [
        // 第一列
        {
          values: [35, 36, 37, 38, 39, 40],
          defaultIndex: 1
        },
        // 第二列
        {
          values: [0.0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9],
          defaultIndex: 2
        }
      ]
    }
  },
  mounted () {
    this.detailId = this.$route.query.detailId
    const token = this.$route.query.token
    if (token) {
      setStore('token', token)
    }
    this.getData()
  },
  destroyed () {
    removeStore('token')
  },
  methods: {
    getData () {
      const requestData = {
        detailId: this.detailId
      }
      getVisitorInfo(requestData).then((res) => {
        if (res.data.code === 200) {
          // 赋值
          if (res.data) {
            const data = res.data.result
            this.showTab = Boolean(data.registerType)
            this.registerType = data.registerType
            this.areasName = data.areasName || ''
            this.doorwayName = data.doorwayName || ''
            this.proprietor = data.proprietor
            this.address = data.address
            this.vehicleFlag = data.vehicleFlag + ''
            this.vehicleNo = data.vehicleNo
            this.handleArr(this.healthyStatus)
          }
        }
      })
    },
    onConfirm (value) {
      console.log(value)
      if (Array.isArray(value)) {
        this.temperature = value[0] + value[1]
      }
      this.showPicker = false
    },
    handleSubmit (e) {
      e.preventDefault()
      if (this.showTab && !this.proprietor) {
        Toast({
          message: '请输入拜访人姓名'
        })
        return
      }
      if (!this.address) {
        Toast({
          message: '请输入具体住址'
        })
        return
      }
      console.log(this.vehicleFlag)
      if (this.vehicleFlag === null) {
        Toast({
          message: '请选择车辆有或无'
        })
        return
      }
      if (this.vehicleFlag === '1' && !this.vehicleNo) {
        Toast({
          message: '请输入车牌号'
        })
        return
      }
      if (!this.box1 && !this.box2 && !this.box3 && !this.box4 && !this.box5) {
        Toast({
          message: '请至少选择一项您的身体状况'
        })
        return
      }
      if (!this.temperature) {
        Toast({
          message: '请输入您的温度'
        })
        return
      }
      if (this.vehicleFlag !== '1') {
        this.vehicleNo = ''
      }
      const data = {
        registerType: +this.showTab,
        detailId: this.detailId,
        proprietor: this.proprietor,
        address: this.address,
        vehicleFlag: this.vehicleFlag,
        vehicleNo: this.vehicleNo,
        healthyStatus: [+this.box1, +this.box2, +this.box3, +this.box4, +this.box5],
        temperature: this.temperature
      }
      const healthy = [+this.box1, +this.box2, +this.box3, +this.box4, +this.box5]
      this.loading = true
      submitVisitorInfo(data).then((res) => {
        console.log(res)
        this.loading = false
        if (res.data.code === 200) {
          this.$router.push({ name: 'submitsuc',
            params: {
              healthyStatus: healthy,
              temperature: this.temperature
            }
          })
        } else {
          // Dialog({ message: res.data.message })
        }
      }).catch(() => {
        this.loading = false
      })
    },
    handleTab (tab) {
      if (tab === 1) {
        this.showTab = true
        if (this.registerType !== 1) {
          this.clearForm()
        } else {
          this.getData()
        }
      } else {
        this.showTab = false
        if (this.registerType === 1) {
          this.clearForm()
        } else {
          this.getData()
        }
      }
    },
    clearForm () {
      this.box1 = false
      this.box2 = false
      this.box3 = false
      this.box4 = false
      this.box5 = false
      this.proprietor = ''
      this.address = ''
      this.vehicleFlag = null
      this.vehicleNo = ''
      this.temperature = null
      this.isActive = false
      this.isColor = '#4f7cf6'
      this.handleArr([])
    },
    handleCheckbox (box) {
      if (box === 1) {
        this.box1 = !this.box1
        if (this.box1) {
          this.box2 = false
          this.box3 = false
          this.box4 = false
          this.box5 = false
        }
      } else if (box === 2) {
        this.box2 = !this.box2
        this.box1 = false
      } else if (box === 3) {
        this.box3 = !this.box3
        this.box1 = false
      } else if (box === 4) {
        this.box4 = !this.box4
        this.box1 = false
      } else if (box === 5) {
        this.box5 = !this.box5
        this.box1 = false
      }
    },
    handleArr (boxArr) {
      if (Array.isArray(boxArr)) {
        boxArr.map((item, index) => {
          if (index === 0) {
            this.box1 = Boolean(item)
          } else if (index === 1) {
            this.box2 = Boolean(item)
          } else if (index === 2) {
            this.box3 = Boolean(item)
          } else if (index === 3) {
            this.box4 = Boolean(item)
          } else if (index === 4) {
            this.box5 = Boolean(item)
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
    /deep/ .van-radio__icon--checked .van-icon {
        background-color: #4f7cf6;
        border-color: #4f7cf6;
    }
    /deep/ .van-slider__bar {
      background-color: #4f7cf6;
      border-color: #4f7cf6;
    }
    /deep/ .van-button--info{
      background-color: #4f7cf6;
      border-color: #4f7cf6;
      width: 90%;
      border-radius: 40px;
    }
    .visitor-wrapper {
        min-height: 150vh;
        background: #f7f7f7;
    }
    .visitor-img {
        position: relative;
        margin: 0 15px;
        padding: 10px 0 5px;
        overflow: hidden;
        .img {
            width: 100%;
            border-radius: 5px;
        }
        .desc {
            position: absolute;
            bottom: 11px;
            box-sizing: border-box;
            width: 100%;
            padding: 3px 16px 3px;
            background: rgba(0, 0, 0, .3);
            text-align: right;
            font-size: 12px;
            color: #fff;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
        }
    }
    .visitor-tab {
        display: flex;
        justify-content: center;
        background: #fff;
        padding: 15px 0;
        .tab-item {
            box-sizing: border-box;
            min-width: 130px;
            margin: 0 10px;
            padding: 6px 30px;
            border-radius: 30px;
            background-color: #fff;
            font-size: 16px;
            text-align: center;
        }
        .tab-item.active {
            background-color: #4f7cf6;
            color: #fff;
        }
    }
    .form-lable {
        box-sizing: border-box;
        width: 100%;
        padding: 8px 15px;
        background-color: #f7f7f7;
        font-size: 14px;
    }
    .form-temperature {
      margin-bottom: 6px;
    }
    .form-control {
        box-sizing: border-box;
        width: 100%;
        padding: 12px 15px;
        background-color: #fff;
        font-size: 14px;
        /deep/ .van-radio {
          display: inline-flex;
          margin-right: 10px;
        }
    }
    .form-input-wrapper {
        padding: 3px 15px;
    }
    .form-input {
        box-sizing: border-box;
        width: 98%;
        padding: 9px 3px;
    }
    .form-input-temperature {
      padding: 3px 40px;
    }
    .form-checkbox {
        display: flex;
        justify-content: space-between;
        .item {
          padding: 3px 8px;
          border: 1px solid #e2e2e2;
          border-radius: 5px;
          background-color: #f7f7f7;
          font-size: 14px;
        }
        .item.active {
          border: 1px solid #4f7cf6;
          background-color: #4f7cf6;
          color: #fff;
        }
    }
    .form-group-button {
        display: flex;
        justify-content: center;
        padding: 30px;
        border: 1px solid transparent;
    }
    .form-button {
        width: 92%;
        padding: 8px 0;
        border-radius: 30px;
        background-color: #4f7cf6;
        font-size: 16px;
        color: #fff;
    }
</style>
